import { offersListUpdated } from '@/events'

export function init () {
  // IG-1252
  offersListUpdated.subscribe((e, { offers } = e.detail) => {
    const hotelCodes = offers.map(offer => offer.Merlin_HotelCode).join(';')
    window.dataLayer.push({ ...window.dataLayerSearchParams, idHotelu: `${hotelCodes}` })
  })
}



// WEBPACK FOOTER //
// ./src/modules/datalayer/listingAllHotels.js